import React from "react";
import { Navigator, Button, Icon } from "react-onsenui";
import MobileAppNavigation from "./MobileAppNavigation";

const style = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    display: "flex",
    flex: 1,
    width: "100%",
    height: "100%",
    background: "#EDECF2"
  },
  app: {
    width: "900px",
    height: "100%",
    position: "relative"
  },
  crash: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  p: {
    marginBottom: "30px"
  }
};

const initialRoute = {
  component: MobileAppNavigation,
  props: { key: "main" }
};

const reloadApp = () => {
  window.location = '/';
};

export default class extends React.Component {
  state = { didCrash: false, error: '', info: '' };

  renderPage(route, navigator) {
    const props = {
      ...(route.props || {}),
      navigator: navigator
    };
    return React.createElement(route.component, props);
  }

  componentDidCatch(error, info) {
    this.setState({ didCrash: true, error, info });
  }

  renderCrash() {
    return (
      <div style={style.container}>
        <div style={style.crash}>
          <Icon id="icon" size={80} icon="fa-skull" />
          <h3>Sorry, the app has broken!</h3>
          <p style={style.p}>{`Error: ${this.state.error}`}</p>
          <Button onClick={() => reloadApp()}>Reload the App</Button>
        </div>
      </div>
    );
  }

  navigatorPostPop() {
    // Go back in path, to main page
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const newPath = [pathParts[0], pathParts[1]].join("/");
    console.log("App.navigatorPostPop: navigating to", newPath);
    window.history.replaceState({ page: 0 }, '', newPath);
  }

  render() {
    if (this.state.didCrash === true) {
      return this.renderCrash();
    }

    return (
      <div style={style.container}>
        <div style={style.app}>
            <Navigator
              initialRoute={initialRoute}
              swipeable={true}
              onPostPop={this.navigatorPostPop.bind(this)}
              renderPage={this.renderPage.bind(this)}
            />
        </div>
      </div>
    );
  }
}
